<template>
    <div>
        <button  class="btn btn-success m-2 float-right" data-toggle="modal" data-target="#create_category_modal">
            {{ $t('label.create-category') }}
        </button>
        <div id="create_category_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div id="create_category_modal_data_sheet" class="modal-body mb-4">
                        <div class="modal-header">
                            <h4 class="modal-title">{{ $t('label.create-category') }}</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="m-4">
                            <form @submit.prevent="action($event, query)" method="post" id="category_form">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="6" md="10">
                                            <kt-form-group>
                                                <kt-form-label for="title">
                                                    {{ $t('label.title') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    dir="rtl"
                                                    name="title"
                                                    id="q_title"
                                                    v-model="query.title"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6">
                                            <button
                                                class="btn btn-success btn-wide float-left"
                                                size="md"
                                                type="submit"
                                                id="create_btn"
                                            >
                                                {{$t('btn.submit')}}
                                            </button>
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            query: {}
        }
    }
}
</script>